import { Select } from "antd";
import React from "react";
import "./formInput.scss";
import { lang } from "../../constants/common.const";

const SelectWithLabel = ({
  label,
  options,
  value,
  valueObj = {},
  onChange,
  hasEmptyvalue = true,
  className = "",
  style = {},
  fontSize,
  allTitle,
  ...other
}) => {
  const { Option } = Select;

  const finalValue = value ? value : valueObj.value || "";
  const renderOption = (options, optionBlank = true, lengthText, fontSize) => {
    if (options && options.length > 0) {
      return (
        <>
          {optionBlank && <Option value="" key="blank">{allTitle ? lang.ALL_SELECT_TITLE : ""}</Option>}
          {options.map((e) => {
            let optionText = e.value || e.name;
            if (lengthText && typeof lengthText === "number") {
              if (optionText.length > lengthText) {
                optionText = optionText.substring(0, lengthText) + "...";
              }
            }
            return (
              <Option
                value={e.key || e.id}
                key={e.key || e.id}
                style={{ fontSize }}
              >
                {optionText}
              </Option>
            );
          })}
        </>
      );
    }
  };
  return (
    <div className="select-with-label__wrapper w100">
      <span
        style={{
          color: other && other.disabled && "#00000040",
          background: other && other.disabled && "#F5F5F5",
          fontSize,
        }}
        className="select-with-label__label"
      >
        {label}
      </span>
      <Select
        filterOption={(input, option) => {
          return (
            option &&
            option.children &&
            String(option.children).toLowerCase().includes(input.toLowerCase())
          );
        }}
        style={style}
        value={finalValue}
        onChange={onChange}
        className={"select-with-label__select " + className}
        {...other}
      >
        {renderOption(options, hasEmptyvalue, null, fontSize)}
      </Select>
    </div>
  );
};

export default SelectWithLabel;
